import axios from "../API/API";
import { FILE_SERVICE_BASE_URL } from "../constant/apiUrl";

const getFileExtensionFromFilename = (filename) => {
  if (!filename) return "bin";
  const parts = filename.split(".");
  return parts.length > 1 ? parts.pop().toLowerCase() : "bin";
};

const extractFileName = (headers, id, extension) => {
  const disposition = headers["content-disposition"];
  console.log(disposition, "---disposition---");

  if (disposition) {
    const match = disposition.match(/filename="(.+?)"/);
    if (match && match[1]) return match[1];
  }

  return `file_${id}.${extension}`;
};

// MIME type mapping
const mimeTypeMap = {
  txt: "text/plain",
  pdf: "application/pdf",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
  svg: "image/svg+xml",
  bin: "application/octet-stream",
};

const fetchAndCacheImageName = async (id, action, dispatch) => {
  try {
    const { data, headers } = await axios.get(
      `${FILE_SERVICE_BASE_URL}/fritolay/file-manager/download-thumbnail-by-id/${id}`,
      {
        headers: {
          "Content-Type": "application/octet-stream",
        },
        responseType: "arraybuffer",
      }
    );

    if (!data) return null;

    const extension = getFileExtensionFromFilename(
      extractFileName(headers, id)
    );
    const mimeType = mimeTypeMap[extension] || "application/octet-stream";

    const fileName = extractFileName(headers, id, extension);
    const blob = new Blob([data], { type: mimeType });
    const url = URL.createObjectURL(blob);

    const fileObject = { id, name: fileName, url, type: extension };

    if (action) dispatch(action(fileObject));

    return fileObject;
  } catch (error) {
    console.error(`Error fetching file for ID ${id}:`, error);
    return null;
  }
};

export default fetchAndCacheImageName;
